export interface TransactionsStatusReason {
  name: string
  id: number
  description: string
  transactionState: {
    id: number
    name: string
  }
}

export enum TransactionsStatusReasonType {
  PriorityCardWithdrawal = 835,
}
